import React, { useContext, useLayoutEffect } from 'react'
import { Outlet } from 'react-router'
import { StoresContext } from '@App/contexts'

const RightsholderRegistrationHistoryLayout = () => {
    const { workStore, registrationHistoryStore } = useContext(StoresContext)
    // Clearing the stores here does not clear the query cache, which keeps the fetched page. On the way back the
    // search is a cache hit, so the results are refilled by `useSearchQuery`'s `applyData`, not by a fetch.
    useLayoutEffect(
        () => () => {
            registrationHistoryStore.resetRegHistory()
            workStore.destroyViewWork()
        },
        []
    )

    return (
        <>
            <title>Registration History</title>
            <Outlet />
        </>
    )
}

export default RightsholderRegistrationHistoryLayout
